import { render } from "./DiscountsBasCreateUpdate.vue?vue&type=template&id=42d11ceb"
import script from "./DiscountsBasCreateUpdate.vue?vue&type=script&lang=js"
export * from "./DiscountsBasCreateUpdate.vue?vue&type=script&lang=js"

import "./DiscountsBasCreateUpdate.vue?vue&type=style&index=0&id=42d11ceb&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__